import React from "react";
import { Waves, TrendingUp } from "lucide-react";
import { t, HULL_LABELS } from "@/lib/i18n";

const fmtUSD = (n) => `$${(n || 0).toLocaleString("en-US")}`;

export default function EarningsByHull({ rows, hulls, lang }) {
  const displayRows =
    rows && rows.length
      ? rows
      : (hulls || []).slice(0, 4).map((h) => ({
          hull_id: h.id,
          hull_name: h.name,
          submitted: 0,
          signed: 0,
          earnings_usd: 0,
        }));

  const maxEarnings = Math.max(1, ...displayRows.map((r) => r.earnings_usd || 0));

  return (
    <section
      className="eigoo-card p-6 sm:p-7 anim-fade-up anim-delay-2"
      data-testid="earnings-by-hull-card"
    >
      <div className="flex items-start justify-between gap-4 mb-5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl grid place-items-center border border-[#d4a843]/40 bg-[#d4a843]/10">
            <Waves className="w-5 h-5 text-[#f3c669]" />
          </div>
          <div>
            <h3 className="font-display text-lg sm:text-xl font-bold">
              {t(lang, "earnings_by_hull")}
            </h3>
            <p className="text-xs text-slate-400 mt-0.5">
              {t(lang, "earnings_by_hull_sub")}
            </p>
          </div>
        </div>
        <TrendingUp className="w-5 h-5 text-slate-500 shrink-0" />
      </div>

      <div className="space-y-3">
        {displayRows.map((r) => {
          const pct = Math.min(100, Math.round((r.earnings_usd / maxEarnings) * 100));
          const label = HULL_LABELS[lang]?.[r.hull_id] || r.hull_name;
          return (
            <div
              key={r.hull_id}
              className="rounded-xl border border-[#1e3a61] bg-[#0f2038]/60 px-4 py-3"
              data-testid={`hull-row-${r.hull_id}`}
            >
              <div className="flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <div className="font-semibold text-sm truncate">{label}</div>
                  <div className="text-[11px] text-slate-400 mt-0.5">
                    {r.submitted} {t(lang, "hull_submitted").toLowerCase()} · {r.signed}{" "}
                    {t(lang, "hull_signed").toLowerCase()}
                  </div>
                </div>
                <div className="font-mono font-bold text-[#f3c669] tabular-nums">
                  {fmtUSD(r.earnings_usd)}
                </div>
              </div>
              <div className="mt-2 h-1.5 rounded-full bg-[#1e3a61]/60 overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-[#d4a843] to-[#f3c669] transition-[width] duration-500"
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>

      {!rows?.length && (
        <p className="text-xs text-slate-500 mt-4 italic">{t(lang, "no_earnings_yet")}</p>
      )}
    </section>
  );
}
